import _ from 'lodash';

const actions = {
    doWork() {
        return {};
    },
};

export default actions;
